import axios from 'axios'

const RESET = 'RESET'

const ARCHIVE_TENANT_URL = (tenantId) => `api/AdminUserGroup/Archive/${tenantId}`
const initialState = () => ({})
export default {
  namespaced: true,
  state: initialState(),
  actions: {
    async archiveTenant(_, {
      tenant,
      tenantId,
    }) {
      try {
        let response = await axios.post(ARCHIVE_TENANT_URL(tenantId || tenant.Id))
        return response.data
      } catch (error) {
        console.error(error)
        throw error.response.data
      }
    },
  },
  mutations: {
    
    [RESET](state) {
      state.configurations = initialState.configurations
    },
  },
}